module.exports = __webpack_public_path__ + "img/vyl-team.7b5c0e9b.jpg";